<template>
    <div class="board-community-section">
        <v-container>
            <div class="d-flex justify-space-between align-center mb-6">
                <h2 class="section-title">กระดานข่าวชุมชน</h2>
                <v-btn color="black" dark rounded small elevation="0" class="px-4" @click="goMore">
                    ดูเพิ่มเติม
                </v-btn>
            </div>

            <div v-if="isLoading" class="d-flex justify-center py-12">
                <v-progress-circular indeterminate size="32" width="3" color="primary" />
            </div>

            <div v-else-if="items.length === 0" class="text-center py-12 grey--text">
                ยังไม่พบข่าวชุมชน
            </div>

            <v-row v-else>
                <v-col v-for="(item, index) in items" :key="item.id" cols="12" md="6">
                    <div class="community-card" @click="goDetail(item.id)">
                        <div class="community-image-wrapper">
                            <v-img :src="toImageUrl(item.image)" aspect-ratio="1.77" cover class="community-image">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </div>
                        <div class="community-content pt-4">
                            <v-chip small color="grey lighten-3" class="mb-2">
                                {{ index === 0 ? 'ใหม่ล่าสุด' : 'แนะนำ' }}
                            </v-chip>
                            <h3 class="community-title">
                                {{ item.title }}
                            </h3>
                            <div class="community-meta mt-1">
                                <span>{{ formatTimeAgo(item.publishedAt) }}</span>
                                <template v-if="item.views">
                                    <span class="meta-sep">·</span>
                                    <v-icon size="11" color="#aaa">mdi-eye-outline</v-icon>
                                    <span>{{ formatViews(item.views) }} ครั้ง</span>
                                </template>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "BoardCommunity",
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toImageUrl(path) {
            if (!path) return "https://placehold.co/800x450?text=No+Image";
            if (path.startsWith("http")) return path;
            const base = process.env.VUE_APP_API_URL || "";
            return `${base}${path}`;
        },
        formatTimeAgo(dateStr) {
            if (!dateStr) return "";
            const published = new Date(dateStr);
            const now = new Date();
            const diffMs = now - published;
            if (diffMs <= 0) return "เมื่อสักครู่";

            const diffMinutes = Math.floor(diffMs / (1000 * 60));
            if (diffMinutes < 60) return `${diffMinutes} นาทีที่แล้ว`;

            const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
            if (diffHours < 24) return `${diffHours} ชั่วโมงที่แล้ว`;

            const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            if (diffDays < 7) return `${diffDays} วันที่แล้ว`;

            const weeks = Math.floor(diffDays / 7);
            if (weeks < 4) return `${weeks} สัปดาห์ที่แล้ว`;

            const months = Math.floor(diffDays / 30);
            if (months < 12) return `${months} เดือนที่แล้ว`;

            const years = Math.floor(diffDays / 365);
            return `${years} ปีที่แล้ว`;
        },
        goMore() {
            this.$router.push({ name: "BoardList" });
        },
        formatViews(n) {
            if (!n) return '0';
            if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
            if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
            return String(n);
        },
        goDetail(id) {
            this.$router.push({ name: "BoardDetail", params: { boardId: id } });
        },
    },
};
</script>

<style scoped>
.board-community-section {
    padding: 60px 0;
    max-width: 1440px;
    margin: 0 auto;
}

.section-title {
    font-size: 24px;
    font-weight: 700;
    color: #000;
}

.community-card {
    cursor: pointer;
    transition: transform 0.2s;
}

.community-card:hover {
    transform: translateY(-4px);
}

.community-image-wrapper {
    overflow: hidden;
    border-radius: 8px;
}

.community-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.4;
    color: #000;
    margin-bottom: 4px;
}

.community-meta {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #888;
    margin-bottom: 0;
}
.meta-sep {
    color: #ccc;
}
</style>